<template>
    <Card :bordered="false" class="border-radius-0">
        <CTable
            :isLoading="isLoading"
            v-model:columns="state.columns"
            v-model:page="state.page"
            :options="state.tableOptions"
            :manages="state.manages"
            :manageExtras="state.manageExtras"
            :rowActions="state.rowActions"
            @search="search => onSearch({ props, state, ...search })"
        ></CTable>
    </Card>
</template>

<script>
import { Card } from "ant-design-vue";
import { defineAsyncComponent, defineComponent, reactive } from "vue";
import { state as stateApp } from "../../../../app.logic";
import { initState, isLoading, onSearch } from "./request.logic";

export default defineComponent({
    components: {
        Card,
        CTable: defineAsyncComponent(() => import("../../../../components/table/CTable"))
    },
    props: {
        menuContext: { default: () => stateApp.menuContext },
        routerPrefix: { default: "storage-location-requests" },
        isLocation: { default: true }
    },
    setup(props) {
        const state = reactive(initState({ props }));
        return { props, isLoading, state, onSearch };
    }
});
</script>
